"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    root: {
        path: "/"
    },
    downloadExport: {
        // This url is used in the /exports/:objectKey route in server/api/files.ts
        // as a splash page for after the user logs in to download the export.
        path: "/download-export/:objectKey"
    },
    exportFile: {
        // Direct API download URL for export files
        path: "/api/files/exports/:objectKey"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvYXBwLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgcm9vdDoge1xuICAgIHBhdGg6IFwiL1wiLFxuICB9LFxuICBkb3dubG9hZEV4cG9ydDoge1xuICAgIC8vIFRoaXMgdXJsIGlzIHVzZWQgaW4gdGhlIC9leHBvcnRzLzpvYmplY3RLZXkgcm91dGUgaW4gc2VydmVyL2FwaS9maWxlcy50c1xuICAgIC8vIGFzIGEgc3BsYXNoIHBhZ2UgZm9yIGFmdGVyIHRoZSB1c2VyIGxvZ3MgaW4gdG8gZG93bmxvYWQgdGhlIGV4cG9ydC5cbiAgICBwYXRoOiBcIi9kb3dubG9hZC1leHBvcnQvOm9iamVjdEtleVwiLFxuICB9LFxuICBleHBvcnRGaWxlOiB7XG4gICAgLy8gRGlyZWN0IEFQSSBkb3dubG9hZCBVUkwgZm9yIGV4cG9ydCBmaWxlc1xuICAgIHBhdGg6IFwiL2FwaS9maWxlcy9leHBvcnRzLzpvYmplY3RLZXlcIixcbiAgfSxcbn0pO1xuIl0sIm5hbWVzIjpbInJvdXRlcyIsImJ1aWxkUm91dGVzIiwicm9vdCIsInBhdGgiLCJkb3dubG9hZEV4cG9ydCIsImV4cG9ydEZpbGUiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxNQUFNO1FBQ0pDLE1BQU07SUFDUjtJQUNBQyxnQkFBZ0I7UUFDZCwyRUFBMkU7UUFDM0Usc0VBQXNFO1FBQ3RFRCxNQUFNO0lBQ1I7SUFDQUUsWUFBWTtRQUNWLDJDQUEyQztRQUMzQ0YsTUFBTTtJQUNSO0FBQ0YifQ==